<div mat-dialog-title>
  {{ title }}
  <div class="spacer"></div>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content>
  <div>
    <mat-form-field floatLabel="always" appearance="outline" class="search">
      <mat-label class="mat-label">{{ 'SEARCH.search' | translate }}</mat-label>
      <input
        id="search"
        #search
        matInput
        (keyup)="monitorSearch(search.value)"
        [placeholder]="'USERS_SEARCH.search_placeholder' | translate"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div>
    @if (noRecordsFound) {
    <div class="not-found">
      {{ message | translate }}
    </div>
    }
    @if (!noRecordsFound) {
    <table
      mat-table
      [dataSource]="usersDataSource"
      [ngClass]="noRecordsFound ? 'hide' : ''"
      matSort
    >
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="selected-label">
          <mat-checkbox
            color="primary"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="isPartiallySelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-header-cell class="border" *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="name-label"
        >
          {{ 'COMPANY_USERS.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let user" class="name-column">
          @if (user.authID) {
          <div>
            {{ user.firstName }} {{ user.lastName }}
          </div>
          }
          @if (user.id) {
          <div>{{ user.name }}</div>
          }
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="email-label">
          {{ 'COMPANY_USERS.email' | translate }}
        </th>
        <td mat-cell *matCellDef="let user" class="email-column">
          {{ user.email }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        class="branch-user-row"
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
      ></tr>
    </table>
    }

    <mat-paginator
      #paginator
      [length]="users?.length"
      [pageSize]="5"
      [ngClass]="users?.length > 5 && !noRecordsFound ? '' : 'hide'"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-stroked-button [mat-dialog-close]="false">
    {{ secondaryButtonText }}
  </button>
  <button
    color="primary"
    mat-flat-button
    [mat-dialog-close]="selection.selected"
  >
    {{ primaryButtonText }}
  </button>
</mat-dialog-actions>
